import { TherapyComplianceDtoTherapyCompliance } from '../api/generated/model';

export function getTherapyComplianceStatusText(complianceStatus: TherapyComplianceDtoTherapyCompliance) {
  switch (complianceStatus) {
    case TherapyComplianceDtoTherapyCompliance.YES:
      return 'Therapie > 80% eingehalten (ja)';
    case TherapyComplianceDtoTherapyCompliance.NO:
      return 'Therapie < 80% eingehalten (nein)';
  }
}
